import { render, staticRenderFns } from "./LabSim.vue?vue&type=template&id=0eb1a5bc&"
import script from "./LabSim.vue?vue&type=script&lang=ts&"
export * from "./LabSim.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports